import type { ThemeName } from "@krainovsd/vue-ui";
import { BehaviorSubject } from "@/lib/behavior-subject";
import { Subject } from "../../lib/subject";
import type { ILanguage, IMessageSubjectPayload, INotificationSubjectPayload } from "./tech.types";

export const notification$ = new Subject<INotificationSubjectPayload>();
export const message$ = new Subject<IMessageSubjectPayload>();
export const theme$ = new BehaviorSubject<ThemeName>("dark");
export const language$ = new BehaviorSubject<ILanguage>(
  (localStorage.getItem("lang") as ILanguage) ?? "ru",
);
language$.subscribe((value) => {
  localStorage.setItem("lang", value);
});
